import { render } from "./StepFourPointFive.vue?vue&type=template&id=c640faf8&scoped=true"
import script from "./StepFourPointFive.vue?vue&type=script&lang=js"
export * from "./StepFourPointFive.vue?vue&type=script&lang=js"

import "./StepFourPointFive.vue?vue&type=style&index=0&id=c640faf8&scoped=true&lang=css"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c640faf8"]])

export default __exports__